// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workspace-sidebar {
  position: fixed;
  left: var(--leftbar-width, 273px);
  z-index: 150;
  height: 100vh;
  top: 0;
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  transition: left 0.2s ease;
  will-change: left;
  overflow-y: auto;
}

/* Hide sidebar during resize */
body.resizing-leftbar .workspace-sidebar {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}

.sidebar-content {
  padding: 16px 16px 0 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.sidebar-content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.sidebar-content-right {
  display: flex;
  gap: 12px;
}

.sidebar-tabs {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.sidebar-tabs .ant-tabs-content-holder {
  flex: 1;
  overflow: auto;
}

.sidebar-tabs .ant-tabs-tab.ant-tabs-tab-active {
  border-radius: 21px !important; /* Border radius */
  background-color: #fff !important; /* Background color */
  border: 1px solid var(--primary-color) !important;
  color: var(--primary-color) !important;
  padding: 0px 16px !important;
  margin-bottom: 8px !important;
}

.sidebar-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: var(--primary-color) !important;
}
/* Optimize rendering */
.workspace-sidebar * {
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

/* Styles for search results */
.search-results-list {
  padding-top: 8px;
  height: 100%;
  overflow-y: auto;
  position: relative;
  scroll-behavior: smooth;
}

.search-results-list::-webkit-scrollbar {
  width: 6px;
}

.search-results-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.search-results-list::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 3px;
}

.search-results-list::-webkit-scrollbar-thumb:hover {
  background: #b3b3b3;
}

.search-result-item {
  padding: 12px;
  margin-bottom: 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
  cursor: pointer;
}

.search-result-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.workspace-avatar {
  display: flex;
  justify-content: center;
  align-items: center;
}

.workspace-title {
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 4px;
}

.workspace-description {
  font-size: 12px;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* Loading indicator for infinite scroll */
.infinite-scroll-loading,
.loading-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0;
  height: 50px;
}

/* Empty state for no search results */
.search-empty-state {
  padding: 40px 0;
}

/* Input field styling */
.sidebar-content .ant-input-affix-wrapper {
  border-radius: 4px;
}

.sidebar-content .ant-list {
  background: white;
  border-radius: 4px;
  margin-top: 8px;
}

.sidebar-content .ant-list-item {
  padding: 8px 12px;
  border-radius: 4px;
}

.sidebar-content .ant-list-item:hover {
  background-color: #f5f5f5;
}

.sidebar-content .ant-list-item-meta-title {
  margin-bottom: 4px;
}

.sidebar-content .ant-list-item-meta-description {
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}

.sidebar-content .ant-select {
  border-radius: 4px;
}

.sidebar-content .ant-switch {
  margin-left: 8px;
}

/* Infinite scroll container */
.infinite-scroll-container {
  position: relative;
  scroll-behavior: smooth;
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,MAAM;EACN,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,8BAA8B,EAAE,kBAAkB;EAClD,iCAAiC,EAAE,qBAAqB;EACxD,iDAAiD;EACjD,sCAAsC;EACtC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;AACxC;AACA,uBAAuB;AACvB;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA,0CAA0C;AAC1C;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,uBAAuB;AACzB","sourcesContent":[".workspace-sidebar {\n  position: fixed;\n  left: var(--leftbar-width, 273px);\n  z-index: 150;\n  height: 100vh;\n  top: 0;\n  padding: 24px 0;\n  display: flex;\n  flex-direction: column;\n  transition: left 0.2s ease;\n  will-change: left;\n  overflow-y: auto;\n}\n\n/* Hide sidebar during resize */\nbody.resizing-leftbar .workspace-sidebar {\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n}\n\n.sidebar-content {\n  padding: 16px 16px 0 16px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.sidebar-content-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.sidebar-content-right {\n  display: flex;\n  gap: 12px;\n}\n\n.sidebar-tabs {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.sidebar-tabs .ant-tabs-content-holder {\n  flex: 1;\n  overflow: auto;\n}\n\n.sidebar-tabs .ant-tabs-tab.ant-tabs-tab-active {\n  border-radius: 21px !important; /* Border radius */\n  background-color: #fff !important; /* Background color */\n  border: 1px solid var(--primary-color) !important;\n  color: var(--primary-color) !important;\n  padding: 0px 16px !important;\n  margin-bottom: 8px !important;\n}\n\n.sidebar-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: var(--primary-color) !important;\n}\n/* Optimize rendering */\n.workspace-sidebar * {\n  backface-visibility: hidden;\n  -webkit-backface-visibility: hidden;\n}\n\n/* Styles for search results */\n.search-results-list {\n  padding-top: 8px;\n  height: 100%;\n  overflow-y: auto;\n  position: relative;\n  scroll-behavior: smooth;\n}\n\n.search-results-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.search-results-list::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.search-results-list::-webkit-scrollbar-thumb {\n  background: #d9d9d9;\n  border-radius: 3px;\n}\n\n.search-results-list::-webkit-scrollbar-thumb:hover {\n  background: #b3b3b3;\n}\n\n.search-result-item {\n  padding: 12px;\n  margin-bottom: 8px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n  cursor: pointer;\n}\n\n.search-result-item:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n\n.workspace-avatar {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.workspace-title {\n  font-size: 14px;\n  line-height: 22px;\n  margin-bottom: 4px;\n}\n\n.workspace-description {\n  font-size: 12px;\n  line-height: 18px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n/* Loading indicator for infinite scroll */\n.infinite-scroll-loading,\n.loading-indicator {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 0;\n  height: 50px;\n}\n\n/* Empty state for no search results */\n.search-empty-state {\n  padding: 40px 0;\n}\n\n/* Input field styling */\n.sidebar-content .ant-input-affix-wrapper {\n  border-radius: 4px;\n}\n\n.sidebar-content .ant-list {\n  background: white;\n  border-radius: 4px;\n  margin-top: 8px;\n}\n\n.sidebar-content .ant-list-item {\n  padding: 8px 12px;\n  border-radius: 4px;\n}\n\n.sidebar-content .ant-list-item:hover {\n  background-color: #f5f5f5;\n}\n\n.sidebar-content .ant-list-item-meta-title {\n  margin-bottom: 4px;\n}\n\n.sidebar-content .ant-list-item-meta-description {\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 12px;\n}\n\n.sidebar-content .ant-select {\n  border-radius: 4px;\n}\n\n.sidebar-content .ant-switch {\n  margin-left: 8px;\n}\n\n/* Infinite scroll container */\n.infinite-scroll-container {\n  position: relative;\n  scroll-behavior: smooth;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
